<template>
  <div
    class="pointer-events-none absolute inset-0 z-0 rounded-[20px]"
    style="
      background: linear-gradient(
        135deg,
        #2de8b0,
        #cbe953 49%,
        #ffab48 76%,
        #ff5151
      );
      padding: 4px;
      mask:
        linear-gradient(#fff 0 0) content-box,
        linear-gradient(#fff 0 0);
      mask-composite: exclude;
      opacity: 0.08;
      box-sizing: border-box;
    "
  />
  <div
    class="pointer-events-none absolute inset-1 z-0 rounded-[16px]"
    style="
      background: linear-gradient(
        135deg,
        #2de8b0 0%,
        #cbe953 49%,
        #ffab48 76%,
        #ff5151 100%
      );
      padding: 1px;
      box-sizing: border-box;
      -webkit-mask:
        linear-gradient(#fff 0 0) content-box,
        linear-gradient(#fff 0 0);
      -webkit-mask-composite: xor;
      mask-composite: include;
    "
  ></div>
  <div
    class="pointer-events-none absolute inset-0"
    style="
      background: linear-gradient(
        135deg,
        #2de8b0 0%,
        #cbe953 49%,
        #ffab48 76%,
        #ff5151 100%
      );
      opacity: 0.08;
    "
  />
</template>
